export default __webpack_public_path__ + "static/media/background.48c0b661.webp";